import React from 'react';
import {Card, CardHeader, CardTitle, CardBody, CardFooter} from 'reactstrap';
import Loading from '../../components/waiting';
import {Link} from 'react-router-dom';

const AlertBlank = props => {
    if (props.count === 0) return null;
    if (!props.count) return <Loading>Loading blank response count . . .</Loading>;
    return (
        <Card className='border-warning'>
            <CardHeader className='bg-warning'>
                <CardTitle>Review Reported Blanks</CardTitle>
            </CardHeader>
            <CardBody>{props.count} responses have been reported blank.</CardBody>
            <CardFooter>
                <Link className='btn btn-warning btn-sm' to='/admin/review-blanks'>
                    Review Blanks
                </Link>
            </CardFooter>
        </Card>
    );
};

export default AlertBlank;
